// const entry = {data:{
import { useMemo, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover.jsx";
import { Button } from "../ui/button.jsx";

const EMOJIS = [
  "😀","😁","😂","🤣","😊","😍","😘","🤩","😉","🤗",
  "👍","👏","🙏","💯","🔥","🎉","✨","🚀","💡","✅",
  "😎","🤔","😢","😡","���","🙌","🥳","😴","😇","🤝"
];

const NEOIN_SVGS = {
  joy: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="joyGrad" x1="4" y1="4" x2="20" y2="20" gradientUnits="userSpaceOnUse"><stop stop-color="#25d366"/><stop offset="1" stop-color="#128c7e"/></linearGradient></defs><circle cx="12" cy="12" r="10" fill="url(#joyGrad)"/><path d="M8.5 10c.6-1 1.6-1.6 3.5-1.6s2.9.6 3.5 1.6" stroke="#ffffff" stroke-width="1.4" stroke-linecap="round"/><path d="M8 14c1.2 1.4 2.7 2.1 4 2.1s2.8-.7 4-2.1" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  calm: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" rx="9" fill="#0b7fab"/><path d="M8 11c1-.8 2-1.2 4-1.2s3 .4 4 1.2" stroke="#b6f3ff" stroke-width="1.4" stroke-linecap="round"/><path d="M8.5 15.5c1 .9 2.1 1.3 3.5 1.3s2.5-.4 3.5-1.3" stroke="#b6f3ff" stroke-width="1.4" stroke-linecap="round"/></svg>`,
  focus: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 3l7 4v10l-7 4-7-4V7l7-4z" fill="#0f172a" stroke="#53bdeb" stroke-width="1.4"/><circle cx="12" cy="12" r="3.6" fill="#53bdeb"/><circle cx="12" cy="12" r="1.4" fill="#0f172a"/></svg>`,
  energy: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2l2.4 5.6 6 1-4.4 4.1 1 6-5-2.7-5 2.7 1-6-4.4-4.1 6-1L12 2z" fill="#f97316" stroke="#f59e0b" stroke-width="1.2"/><path d="M10.8 13.6l1.2-2.8H9.6L13.2 7l-1.2 2.7h2.4l-3.6 3.9z" fill="#fff"/></svg>`,
  support: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="4" y="6" width="16" height="12" rx="6" fill="#2563eb"/><path d="M7 13l2.5 1.9c1 .8 2.4.8 3.4 0L18 11" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  spark: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><defs><radialGradient id="sparkGrad" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(12 12) scale(10)"><stop stop-color="#a855f7"/><stop offset="1" stop-color="#1d4ed8"/></radialGradient></defs><circle cx="12" cy="12" r="10" fill="url(#sparkGrad)"/><path d="M12 5l1.2 3.8H17l-3 2.2 1.1 3.7L12 12.8 8.9 14.7 10 11l-3-2.2h3.8L12 5z" fill="#fff"/></svg>`,
  uplift: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 15.5c2-2.8 4.2-4.2 8-4.2s6 1.4 8 4.2" stroke="#22c55e" stroke-width="1.6" stroke-linecap="round"/><circle cx="9" cy="9" r="1.6" fill="#22c55e"/><circle cx="15" cy="9" r="1.6" fill="#22c55e"/><path d="M12 7.5c1.3 0 2.2-.6 3.1-1.6" stroke="#22c55e" stroke-width="1.4" stroke-linecap="round"/></svg>`,
  relief: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="10" fill="#1f2937"/><path d="M8 12.2c.9 1.7 2.3 2.6 4 2.6s3.1-.9 4-2.6" stroke="#38bdf8" stroke-width="1.5" stroke-linecap="round"/><path d="M8.5 9.4l1.6-.8M15.5 9.4l-1.6-.8" stroke="#38bdf8" stroke-width="1.4" stroke-linecap="round"/></svg>`,
  celebrate: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 18l3.5-9.5c2.3.5 4.4 1.8 5.9 3.7s2.3 4 2.3 6.3H4z" fill="#d946ef"/><path d="M10.5 9.2l5.5-5.2M12.8 12.6l6.4-3.2M13.6 15.8l4.8-.2" stroke="#fdf2f8" stroke-width="1.4" stroke-linecap="round"/></svg>`,
};

const NEOIN_EMOJIS = {
  energy: [
    { key: "joy", label: "Joyful boost", caption: "Brighten the room", text: ":neoin-joy:", svg: NEOIN_SVGS.joy, tone: "citrus" },
    { key: "spark", label: "Spark inspiration", caption: "Kick off ideas", text: ":neoin-spark:", svg: NEOIN_SVGS.spark, tone: "cosmic" },
    { key: "energy", label: "Energy burst", caption: "Fire up momentum", text: ":neoin-energy:", svg: NEOIN_SVGS.energy, tone: "ember" },
  ],
  emotions: [
    { key: "uplift", label: "Feeling uplifted", caption: "Celebrate progress", text: ":neoin-uplift:", svg: NEOIN_SVGS.uplift, tone: "sprout" },
    { key: "relief", label: "Calm relief", caption: "Exhale together", text: ":neoin-relief:", svg: NEOIN_SVGS.relief, tone: "midnight" },
    { key: "calm", label: "Steady calm", caption: "Hold steady", text: ":neoin-calm:", svg: NEOIN_SVGS.calm, tone: "lagoon" },
  ],
  focus: [
    { key: "focus", label: "Deep focus", caption: "Lock in", text: ":neoin-focus:", svg: NEOIN_SVGS.focus, tone: "slate" },
    { key: "support", label: "Supportive nudge", caption: "Got your back", text: ":neoin-support:", svg: NEOIN_SVGS.support, tone: "wave" },
    { key: "celebrate", label: "Celebration", caption: "Big applause", text: ":neoin-celebrate:", svg: NEOIN_SVGS.celebrate, tone: "blush" },
  ],
};

export default function EmojiPicker({ onSelect, children }){
  const [tab, setTab] = useState("std");
  const neoKeys = useMemo(() => Object.keys(NEOIN_EMOJIS), []);
  const [neoCat, setNeoCat] = useState(neoKeys[0] || "energy");
  return (
    <Popover>
      <PopoverTrigger asChild>
        {children || <Button variant="ghost" size="icon" className="h-8 w-8" title="Emoji">😀</Button>}
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[240px] p-2">
        {/* <div className="mb-2 grid grid-cols-2 gap-1 text-xs"> */}
          {/* <button className={`rounded-md px-2 py-1 ${tab==="std"?"bg-secondary":"hover:bg-secondary"}`} onClick={()=>setTab("std")}>Emoji</button> */}
          {/* <button className={`rounded-md px-2 py-1 ${tab==="neo"?"bg-secondary":"hover:bg-secondary"}`} onClick={()=>setTab("neo")}>NEOIN</button> */}
        {/* </div> */}
        <div className="mb-2 grid grid-cols-2 gap-1 text-xs">
  <button
    className={`rounded-md px-2 py-1 text-center ${
      tab === "std" ? "bg-secondary text-white" : "bg-transparent text-gray-400"
    }`}
    onClick={() => setTab("std")}
  >
    Emoji
  </button>
</div>
        {tab === "std" ? (
          <div className="grid grid-cols-8 gap-1">
            {EMOJIS.map((e, i)=> (
              <button key={i} className="text-xl hover:bg-secondary rounded" onClick={()=> onSelect?.(e)} aria-label={`insert ${e}`}>{e}</button>
            ))}
          </div>
        ) : (
          <div>
            <div className="mb-2 grid grid-cols-3 gap-1 text-[11px]">
              {Object.keys(NEOIN_EMOJIS).map((k)=> (
                <button key={k} onClick={()=>setNeoCat(k)} className={`rounded-md px-2 py-1 ${neoCat===k?"bg-secondary":"hover:bg-secondary"}`}>{k}</button>
              ))}
            </div>
            <div className="grid gap-2 sm:grid-cols-2">
              {NEOIN_EMOJIS[neoCat].map((e)=> (
                <button
                  key={e.key}
                  className="neo-emoji"
                  data-tone={e.tone}
                  onClick={()=> onSelect?.(e.text)}
                  aria-label={`${e.label} emoji`}
                  title={e.label}
                >
                  <span className="neo-emoji-icon" aria-hidden dangerouslySetInnerHTML={{ __html: e.svg }} />
                  <span className="neo-emoji-copy">
                    <span className="neo-emoji-title">{e.label}</span>
                    <span className="neo-emoji-caption">{e.caption}</span>
                  </span>
                </button>
              ))}
            </div>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
}
